import { FC } from 'react';
import { Button, Card, Col, Form, Row } from "antd";
import * as React from "react";

import SelectPublishField from '../fields/select-publish-field';
import { useSearchParams } from 'react-router-dom';
import SelectCategoriesField from '../fields/select-category-field';
import SelectForTestField from '../fields/select-for-test-field';
import SelectProductTypeField from '../fields/select-product-type-field';
import SelectUnitField from '../fields/select-unit-field';
import SelectApiField from '../fields/select-api-field';

interface Prop {
	onFinish: (data: any) => any
}

const ProductFilter: FC<Prop> = ({ onFinish }) => {
	const [form] = Form.useForm();
	const [searchParams] = useSearchParams()

	React.useEffect(() => {
		form.setFieldValue("published", searchParams.get("published"))
		form.setFieldValue("type", searchParams.get("type"))
		form.setFieldValue("unit", searchParams.get("unit"))
		form.setFieldValue("api", searchParams.get("api"))
		form.setFieldValue("category", searchParams.get("category"))
		form.setFieldValue("forTest", searchParams.get("forTest"))
		onFinish(form.getFieldsValue())
	}, [])

	return (
		<Card style={{ marginBottom: "16px" }}>
			<Form form={form} onFinish={onFinish} layout="horizontal"  autoComplete='off'>
				<Row gutter={16}>

					<Col xs={24}  md={12} xl={6}  >
						<Form.Item name="published" label="انتشار" 	>
							<SelectPublishField allowClear />
						</Form.Item>
					</Col>

					<Col xs={24}  md={12} xl={6}  >
						<Form.Item name="type" label="نوع">
							<SelectProductTypeField allowClear />
						</Form.Item>
					</Col>

					<Col xs={24}  md={12} xl={6}  >
						<Form.Item name="unit" label="واحد">
							<SelectUnitField allowClear />
						</Form.Item>
					</Col>

					<Col xs={24}  md={12} xl={6} >
						<Form.Item name="category" label="دسته" >
							<SelectCategoriesField allowClear />
						</Form.Item>
					</Col>


					<Col xs={24}  md={12} xl={6}  >
						<Form.Item name="forTest" label="تستی">
							<SelectForTestField allowClear />
						</Form.Item>
					</Col>

					<Col xs={24}  md={12} xl={6}  >
						<Form.Item name="api" label="ای پی آی">
							<SelectApiField allowClear />
						</Form.Item>
					</Col>

					<Col span={24} style={{ textAlign: 'left' }}>
						<Button type="primary" htmlType="submit">جستجو</Button>
					</Col>
				</Row>
			</Form>
		</Card>
	)
}

export default ProductFilter;
